import React from 'react';
import SMReputationListView from 'components/reputations/SMReputationListView';
import SMSearchPagerView from 'components/search/SMSearchPagerView';
import moment from 'moment';
import SMConst from 'lib/SMConst';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMOwnerHelper from 'components/helpers/SMOwnerHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMRestClient from 'lib/SMRestClient';

class SMSpaceReputationListView extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
    };
  }
  
  componentDidMount() {
  }
  
  render() {
    
    const space = this.props.space;
    const owner = space.owner;
    let authRows = [];
    if (owner.is_verified_facebook) {
      authRows.push(<li key="facebook"><i className="fa fa-check"></i>{I18n.t("dashboard.label_000098")}</li>);
    }
    if (owner.is_verified_email) {
      authRows.push(<li key="email"><i className="fa fa-check"></i>{I18n.t("dashboard.label_000095")}</li>);
    }
    if (owner.is_verified_tel) {
      authRows.push(<li key="tel"><i className="fa fa-check"></i>{I18n.t("dashboard.label_000096")}</li>);
    }
    const createdAt = moment(owner.created_at).format("YYYY/MM/DD");
    
    let goldSuperHost = null;
    if (owner.rank && owner.rank == SMConst.OwnerRank.SuperHost) {
      goldSuperHost = <img src={SMRailsBridge.assetPath.goldSuperHost} alt="トップホスト" className="side-space__host-superhost" />;
    }
    
    const evaluateConfirmRate = SMOwnerHelper.ownerEvaluationImage(owner.confirm_rate_evaluation);
    const evaluateReplyRate = SMOwnerHelper.ownerEvaluationImage(owner.reply_rate_evaluation);
    const evaluateReplyTimeAvg = SMOwnerHelper.ownerEvaluationImage(owner.reply_time_avg_evaluation);
    
    return(
      <div className="site-main">
        <div className="page__even page__padding">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <div className="site-sidebar">
                  <a href={Routes.space_path(space.username)}>
                    <div className="side-space__units">
                      <img src={SMFormatHelper.spaceImageURL(space, {width: 630, height: 420, crop: 'pad', background: '#9c9c9c'})} alt={SMFormatHelper.spaceName(space)} />
                      <h1 className="side-space__units-title">{SMFormatHelper.spaceName(space)}</h1>
                    </div>
                  </a>
                  <h2 className="site-sidebar__headline site-sidebar__headline-bt">このスペースの管理者</h2>
                  <div className="site-sidebar__inner">
                    <div className="mod-host__icon-inner">
                      <a href={Routes.owner_path(owner.username)}><img src={SMFormatHelper.ownerImageUrl(owner, owner.profile_image)} alt={owner.name} className="side-space__host-icon fl" /></a>
                      {goldSuperHost}
                    </div>
                    <div className="side-space__host clearfix">
                      <p className="side-space__host-date">登録日<span className="side-host__date-days">{createdAt}</span></p>
                      <h3 className="side-space__host-name link__subcolor"><a href={Routes.owner_path(owner.username)}>{SMFormatHelper.ownerName(owner)}</a></h3>
                    </div>
                    <div className="side-space__host-evaluate row">
                      <div className="col-xs-4">
                        <p className="mod-evaluate__title">{I18n.t("service.label_000058")}
                          <span className="mod-evaluate__help">
                            <i className="fa fa-question-circle mod-evaluate__question"></i>
                            <span className="mod-tooltip mod-evaluate__help-tooltip">
                              <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail mod-evaluate__help-baloon">
                                <span className="baloon-inner">予約リクエストが承認された実績等を元に、スペースマーケットが算出した表記です。</span>
                              </span>
                            </span>
                          </span>
                        </p>
                        <div className="mod-evaluate__value">
                          <img src={evaluateConfirmRate} alt="" className="mod-evaluate__value-img" />
                          <span className="mod-evaluate__value-text">{owner.confirm_rate_text}</span>
                        </div>
                      </div>
                      <div className="col-xs-4">
                        <p className="mod-evaluate__title">{I18n.t("service.label_000006")}</p>
                        <div className="mod-evaluate__value">
                          <img src={evaluateReplyRate} alt="" className="mod-evaluate__value-img" />
                          <span className="mod-evaluate__value-text">{owner.reply_rate_text}</span>
                        </div>
                      </div>
                      <div className="col-xs-4">
                        <p className="mod-evaluate__title">{I18n.t("service.label_000007")}</p>
                        <div className="mod-evaluate__value">
                          <img src={evaluateReplyTimeAvg} alt="" className="mod-evaluate__value-img" />
                          <span className="mod-evaluate__value-text">{owner.reply_time_avg_text}</span>
                        </div>
                      </div>
                    </div>
                    <p className="side-space__host-text">{owner.profile}</p>
                    <div className="side-space__authentication clearfix">
                      <img className="side-space__authentication-icon" src={SMRailsBridge.assetPath.certificationMark} alt={I18n.t("service.label_000010")} />
                      <div className="side-space__authentication-check">
                      <h2 className="side-space__authentication-headline">スペースマーケットによって認証されたホストです。</h2>
                        <ul className="user-authentication__check-list">
                          {authRows}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="side-space__backlink"><a href={Routes.reputations_space_path(space.username)} className="a__underline"><i className="fa fa-chevron-left"></i>スペース詳細に戻る</a></p>
              </div>
                      
              <div className="col-sm-12 col-md-8">
                <div className="mod-review">
                  <h2 className="page-subtitle">評価とレビュー</h2>
                  <ul className="mod-review__head">
                    <li className="mod-review__head-star">
                      <a href={Routes.reputations_owner_path(owner.username)}>{SMRenderHelper.renderReviewStars(space.reputation_score)}</a>
                    </li>
                    <li className="mod-review__head-rating" itemProp="ratingValue">{space.reputation_score}</li>
                    <li itemProp="reviewCount">
                      <a href={Routes.reputations_owner_path(owner.username)} className="space-head__list-number">{space.reputation_count}件</a>
                    </li>
                  </ul>
                  <SMReputationListView reputated="Space" reputations={this.props.reputations} />
                </div>
                <SMSearchPagerView
                  delegate={this}
                  perPage={this.props.perPage}
                  totalCount={this.props.totalCount}
                  currentPage={this.props.currentPage}
                  options={{className: "details__main-nav"}}
                  links={SMRestClient.parseLinkString(this.props.linkString)} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
}
export default SMSpaceReputationListView;



// WEBPACK FOOTER //
// ./app/javascript/components/spaces/SMSpaceReputationListView.jsx